export default {
  LotteryNumNotEnough: "У вас нет попыток участия в розыгрыше.",
  NoOfficialWebsiteReservation: "У вас нет подписки на игру. Сперва подпишитесь.",
  VoteDelNumNotEnough: 'Вы завершили задание.',
  // FlowHasNotBegin: "Событие еще не началось.",
  // FlowHasEnd: "Событие закончилось.",
  ToFastRequest: 'Вы отправляете запросы слишком часто. Повторите попытку позже.',
  // serverError: 'Система перегружена. Повторите попытку позже.',
  unclaimed: 'Не получено',
  validEmail: 'Введите верный адрес эл. почты.',
  longText: 'Текст слишком длинный.',
  enter: "Введите",
  comingSoon: 'Скоро появится',

  raffle3: "Целебное зелье ур.30*10", 
  raffle4: "Целебное зелье ур.30*10", 
  raffle5: "Зелье атаки*2", 
  raffle6: "Зелье атаки*2", 
  raffle7: "Зелье атаки*2", 
  raffle8: "Зелье крит.*5", 
  raffle81: "Карта Ozon $500", 
  raffle82: "Карта Ozon $300", 
  raffle83: "Карта Ozon $100", 
  raffle84: "Карта Ozon $15", 

  pls_input_info: 'Пожалуйста, введите информацию для входа.',
  serverError: 'Ошибка сервера',
  networkError: 'Ошибка сети',
  pleaseLogIn: 'Пожалуйста, войдите в систему',
  RoleInfoNotSaved: 'Информация о персонаже не сохранена.',
  no_role_found: 'Информация о персонаже не найдена',
  NoRoleInfo: 'Информация о персонаже не найдена',
  RoleInfoHasSaved: 'Информация о персонаже сохранена',
  FlowHasNotBegin: 'Событие еще не началось',
  FlowHasEnd: 'Событие завершено.',
  MiddlewareFlowLock: 'Обновление происходит слишком быстро, попробуйте позже.',
  please_select: 'Пожалуйста, выберите',
  share_failed: 'Поделиться не удалось',
  laodingPic: 'Генерация изображения...',
  loading: 'Загрузка...',
};
